import { FormControl, FormHelperText, FormLabel, HStack, Text, Textarea as ChakraTextarea, TextareaProps as ChackraTextareaProps, Tooltip } from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError } from 'react-hook-form';
import { BsFillInfoCircleFill } from 'react-icons/bs';

interface TextareaProps extends ChackraTextareaProps {
  name: string;
  label?: string;
  error?: FieldError;
  help?: string;
  readonly?: boolean;
  width?: string | number;
  count?: number;
  viewTooltip?: boolean;
  tooltipLabel?: string;
}

const TextareaBase: ForwardRefRenderFunction<HTMLTextAreaElement, TextareaProps> = ({ name, label, error, readonly, width, help, count, viewTooltip, tooltipLabel, ...rest }, ref) => (
  <FormControl isInvalid={!!error} w={width}>
    {!!label && (
      <FormLabel htmlFor={name} mb="0.5" onClick={e => e.stopPropagation()}>
        <HStack w="100%">
          <Text fontWeight="bold" fontSize="xs">
            {label}
          </Text>
          {!!viewTooltip && (
            <Tooltip label={tooltipLabel} bg="gray.100" color="black" placement="top-start">
              <span>
                <BsFillInfoCircleFill size={16} color="#ffb818" />
              </span>
            </Tooltip>
          )}
          {!!error && (
            <Text fontSize="xs" color="red.500" whiteSpace="nowrap">
              {error.message}
            </Text>
          )}
        </HStack>
      </FormLabel>
    )}
    <ChakraTextarea
      id={name}
      name={name}
      variant="filled"
      bg="transparent"
      borderColor="#D1D1D1"
      _focus={{ borderColor: 'activeblue.500' }}
      _hover={{ borderColor: 'gray.500' }}
      readOnly={readonly}
      ref={ref}
      minH="70px"
      py="6px"
      lineHeight="24px"
      // size="sm"
      {...rest}
    />
    <Text fontSize="sm"> {count} / 500</Text>
    {/* {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>} */}
    {help && (
      <FormHelperText fontSize="xs" color="#D1D1D1">
        {help}
      </FormHelperText>
    )}
  </FormControl>
);

export const Textarea = forwardRef(TextareaBase);
